module.exports = __webpack_public_path__ + "static/media/css7.c46e3b16.png";